import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "student-alert-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "studentAlertsSettings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      const reducer = module.default;
      const key = module.NAME;
      injectReducer(store, { key, reducer });
      return component;
    })
  ),
});
